var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.96232 10.9311C8.70645 10.9311 10.931 8.70657 10.931 5.96245C10.931 3.21832 8.70645 0.993774 5.96232 0.993774C3.2182 0.993774 0.993652 3.21832 0.993652 5.96245C0.993652 8.70657 3.2182 10.9311 5.96232 10.9311Z",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9624 2.9812V5.9624L7.94987 6.95614",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9248,
    height: 11.9248,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockicon);
export default __webpack_public_path__ + "static/media/clock icon.3f5427dc8cfb80d869957ebc131c0fb0.svg";
export { ForwardRef as ReactComponent };